import { ChevronDown } from "lucide-react";
import CustomButton from "../../components/customButton";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { scrollToTop } from "../../lib/utils";

const Prices = () => {
  const tab = ["chaque semaine", "chaque jour", "chaque mois"];
  const [frequence, setFrequence] = useState("chaque semaine");
  const navigate = useNavigate();
  const { t } = useTranslation()

  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <div
      className="h-full flex flex-col items-center gap-6 "
      style={{
        backgroundImage: `url('/priceBG.svg')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h1 className="text-[27px] font-normal">
        {t("prix_marchandise_marche")}
      </h1>

      <div className="pt-4 w-full max-w-[600px] px-5 flex flex-col items-center gap-4 pb-8 rounded-[8px]"
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
      >
        <div>
          <h2 className="text-[18px]">{t("souscription_trimestre")}</h2>
          <h4 className="text-[12px] text-secondary">
            {t("renouvellement")}
          </h4>
        </div>

        <div className="w-full flex items-center justify-between">
          <div className="h-[130px] w-[130px] rounded-full bg-third flex flex-col justify-center items-center">
            <span className="text-[19px]">1000F </span>
            <span className="text-[7px]">{t("chaque_mois")}</span>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col">
              <h5 className="text-[13px]">{t("methode_alerte")}</h5>
              <p className="text-[8px]">
                {t("nouvelle_information")}
              </p>
            </div>
            <div className="flex flex-row">
              <label className="flex  items-center space-x-4 mr-4">
                <input type="radio" name="payment" value="OM" />
                <span className="text-sm ">SMS</span>
              </label>
              <label className="flex  items-center space-x-4 mr-4">
                <input type="radio" name="payment" value="MOMO" />
                <span className="text-sm ">Notification</span>
              </label>
            </div>
            <div>
              <h5 className="text-[13px]">{t("planification")}</h5>

              <DropdownMenu>
                <DropdownMenuTrigger className="w-full">
                  <CustomButton className="bg-softGrey text-[13px] flex justify-between px-4 py-2 w-full">
                    <span>{frequence}</span>
                    <ChevronDown />
                  </CustomButton>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-56">
                  <DropdownMenuGroup>
                    {tab.map((item, index) => {
                      return (
                        <DropdownMenuItem
                          key={index}
                          onClick={() => {
                            setFrequence(item);
                          }}
                        >
                          <span>{item}</span>
                        </DropdownMenuItem>
                      );
                    })}
                  </DropdownMenuGroup>
                  <DropdownMenuSeparator />
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
        <CustomButton
          rounded
          className="px-4 py-2 text-white w-full max-w-[240px] bg-primary"
          onClick={() => navigate("/paiement_sous")}
        >
          {" "}
          {t("souscrire_service")}
        </CustomButton>
      </div>
    </div>
  );
};
export default Prices;
